import { render } from "./IndustryPlatformDetail.vue?vue&type=template&id=c1f88e88&scoped=true"
import script from "./IndustryPlatformDetail.vue?vue&type=script&lang=js"
export * from "./IndustryPlatformDetail.vue?vue&type=script&lang=js"

import "./IndustryPlatformDetail.vue?vue&type=style&index=0&id=c1f88e88&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f88e88"]])

export default __exports__